@for (pair of timerDigitPairs(seconds()); track $index) {
  <span class="countdown-bar__timer-pair">
    @for (digit of pair; track $index) {
      <span class="countdown-bar__digit">{{ digit }}</span>
    }
  </span>
}
